module.exports = __webpack_public_path__ + "static/img/star_person_team.ec096ad5.png";